import React, { CSSProperties } from 'react'
import { DividerComponent } from './atom'

interface Props {
  width: string
  height: string
  style?: CSSProperties
  color?: string
}

export const Divider = ({ width, height, style, color = '#333333' }: Props) => {
  return <DividerComponent style={style} width={width} height={height} color={color} />
}
